import {ValueObject} from '@s-ui/domain'

export class GetLoanUrlB2CTransactionsRequest extends ValueObject {
  /**
   * @param {String} loanId
   **/

  static validate({loanId, validationError}) {
    const invalidAdId = loanId === undefined || loanId === null || loanId === ''
    if (invalidAdId) throw validationError('loanId is required')
  }
}
